"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCALE = void 0;
const transform_1 = require("./transform");
const IN = 'scale-in';
const OUT = 'scale-out';
(0, transform_1.createTransformKeyFrame)(IN, 'scale(0)', 'scale(1)');
(0, transform_1.createTransformKeyFrame)(OUT, 'scale(1)', 'scale(0)');
exports.SCALE = { IN, OUT };
//# sourceMappingURL=scale.js.map